import { Award, CalendarCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const POINTS = [
  { id: "date", Icon: CalendarCheck, text: "Metti a disposizione date di visita in azienda per gli istituti: le scuole ti trovano nel marketplace, prenotano la data e ricevi lo sconto ospitalità sul pacchetto (€ 120 Horizon · € 540 Vision · € 900 Omega all'anno)." },
  { id: "attestato", Icon: Award, text: "Omega: Attestato Social Impact rilasciato da Prodigy Incorporated con ore, studenti e visite dell'anno, da usare nel bilancio di sostenibilità." },
];

export const SquadraDomani = () => (
  <section className="relative px-6 py-20 lg:py-40" data-testid="squadra-section">
    <Reveal className="max-w-[900px] mx-auto">
      <h2 className="font-extrabold tracking-[-0.04em] leading-[1.02] text-4xl sm:text-5xl lg:text-6xl">
        Formazione Scuola-Lavoro (ex PCTO) <span className="text-titanium">e Attestato Social Impact</span>
      </h2>
      <p className="mt-10 text-xl lg:text-[1.5rem] leading-[1.7] font-light text-titanium" data-testid="squadra-body">
        Ospitare gli studenti in azienda significa toccare con mano il potenziale delle generazioni future e costruire
        oggi la squadra di domani.
      </p>
      <ul className="mt-12 space-y-6">
        {POINTS.map(({ id, Icon, text }) => (
          <li key={id} className="flex gap-5" data-testid={`squadra-point-${id}`}>
            <span className="h-11 w-11 shrink-0 rounded-2xl border border-[#1e2024] flex items-center justify-center">
              <Icon className="h-5 w-5 text-cyan" strokeWidth={1.5} />
            </span>
            <p className="text-base sm:text-lg leading-relaxed text-white/85">{text}</p>
          </li>
        ))}
      </ul>
    </Reveal>
  </section>
);
